import {Component, Input, OnInit} from '@angular/core';
import {LovValueSummary} from '../../model/lovValueSummary.model';
import {LovValuePaginatedService} from "../../../impl/service/lovValuePaginated.service";

@Component({
  selector: 'app-lov-value-summary-field',
  templateUrl: './lov-value-summary-field.component.html',
  styles: [
  ]
})
export class LovValueSummaryFieldComponent implements OnInit {

  @Input() label: string;
  @Input() lovValueSummary: LovValueSummary;
  @Input() textColor: string;
  @Input() iconName: string;

  constructor() { }

  ngOnInit(): void {
  }

}
